export const composerSkillPresets = []

export const composerModelPresets = [
  'FengBaoAuto',
  'GLM-5.0',
  'GLM-4.7 0',
  'Kimi-K2.5',
  'MiniMax-M2.7',
  'DeepSeek-V3.23.2'
]

export const commandPresets = [
  { id: 'status',    cmd: '/status',    label: '/status',    desc: '查看当前状态。' },
  { id: 'reasoning', cmd: '/reasoning', label: '/reasoning', desc: '切换思考显示。' },
  { id: 'new',       cmd: '/new',       label: '/new',       desc: '新开一个会话。' },
  { id: 'reset',     cmd: '/reset',     label: '/reset',     desc: '重置当前会话。' },
  { id: 'help',      cmd: '/help',      label: '/help',      desc: '查看所有命令。' },
]
